<template>
  <div class="content">
    <h1 class="content__title">Lista de Tipos de Atributos</h1>
    <span class="content__details">Listado de tipos de atributos de los productos como colores, tamaños, formas, tipos, colores y otros</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de Tipos de Atributos</h2>
          <div class="main__results">
            <div class="result" v-if="types === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!types">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(type, index) in types" :key="index">
              <div class="result__data">
                <h2 class="result__title" v-text="type.name_es"></h2>
              </div>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'attributeTypeEdit', params: {id: type.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deleteType(type.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'productList', params: {page: 1}}">Lista de Productos</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeList', params: {page: 1}}">Lista de Atributos</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeTypeNew'}">Nuevo Tipo</router-link>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      types: 'loading',
      confirm: false,
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.getTypes()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.getTypes()
    }
  },
  methods: {
    deleteType: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'attribute_types'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getTypes()
            this.$store.commit('notificate', {
              title: 'TIPO BORRADO',
              text: 'El tipo de atributo ha sido borrado correctamente.',
              type: 'success'
            })
          }
        )
    },
    getTypes: function () {
      let httpRequest = {
        module: 'attribute_types',
        params: '?fields=name_es,id&limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination'
      }
      this.get(httpRequest)
        .then(
          types => {
            this.types = types.data
            this.pagination.pages = types.pagination.pages
            this.pagination.currentPage = types.pagination.current_page
            this.pagination.results = types.pagination.results
          }
        )
        .catch(
          () => {
            this.types = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'attributeTypeList', params: {page: this.page - 1}})
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../../assets/sass/objects/_btns"
</style>


// WEBPACK FOOTER //
// src/components/products/attributes/type.list.vue